<template>
    <div class="user_mm no-trans" v-loading="loading">
        <div class="page_name">新增发票抬头</div>
        <div class="info_box">
            <div class="form_flex">
                <div class="form_title">
                    <span>*</span>
                    抬头类型
                </div>
                <div class="input2">
                    <!-- <el-input v-model="forms.name" placeholder="请选择抬头类型"></el-input> -->
                    <el-select v-model="forms.type" placeholder="请选择" @change="change_type">
                        <el-option
                        v-for="(item,index) in type_list"
                        :key="item.value"
                        :label="item.title"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="form_flex" v-if="forms.type==2">
                <div class="form_title">
                    <span>*</span>
                    公司名称
                </div>
                <div class="input2">
                    <el-input v-model="forms.company" placeholder="请输入公司名称"></el-input>
                </div>
            </div>
            <div class="form_flex"  v-if="forms.type==1">
                <div class="form_title">
                    <span>*</span>
                    发票抬头
                </div>
                <div class="input2">
                    <el-input v-model="forms.taitou" placeholder="请输入您的姓名"></el-input>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    <span v-if="forms.type==2">*</span>
                    
                    {{ forms.type==1?"身份证号":"纳税人识别码" }}
                </div>
                <div class="input2">
                    <!-- 请输入纳税人识别码 -->
                    <el-input v-model="forms.taxpayer_number" :placeholder="nsr_text"></el-input>
                </div>
            </div>
            <div class="form_flex" v-if="forms.type==2">
                <div class="form_title">
                    <!-- <span>*</span> -->
                    公司地址
                </div>
                <div class="input2">
                    <el-input v-model="forms.address" placeholder="请输入公司地址"></el-input>
                </div>
            </div>
            <div class="form_flex" v-if="forms.type==2">
                <div class="form_title">
                    <!-- <span>*</span> -->
                    公司电话
                </div>
                <div class="input2">
                    <el-input v-model="forms.mobile" placeholder="请输入公司电话"></el-input>
                </div>
            </div>
            <div class="form_flex" v-if="forms.type==2">
                <div class="form_title">
                    <!-- <span>*</span> -->
                    公司开户行
                </div>
                <div class="input2">
                    <el-input v-model="forms.bank" placeholder="请输入公司开户行"></el-input>
                </div>
            </div>
            <div class="form_flex" v-if="forms.type==2">
                <div class="form_title">
                    <!-- <span>*</span> -->
                    开户行帐号
                </div>
                <div class="input2">
                    <el-input v-model="forms.bank_num" placeholder="请输入开户行帐号"></el-input>
                </div>
            </div>
            <div class="form_flex" v-if="forms.type==1">
                <div class="form_title">
                    <!-- <span>*</span> -->
                    联系电话
                </div>
                <div class="input2">
                    <el-input v-model="forms.mobile" placeholder="请输入联系电话"></el-input>
                </div>
            </div>

            <div class="form_flex">
                <div class="form_title">
                    <!-- <span>*</span> -->
                    备注
                </div>
                <div class="input2">
                    <el-input v-model="forms.remark" placeholder="请输入备注内容"></el-input>
                </div>
            </div>
            <div class="form_flex">
                <div class="form_title">
                    <span>*</span>
                    接收电子邮箱
                </div>
                <div class="input2">
                    <el-input v-model="forms.email" placeholder="请输入电子邮箱"></el-input>
                </div>
            </div>
            
             
            
     
            <div class="form_flex">
                <div class="form_title">
                </div>
                <div class="btn_flex">
                    <div class="btns1" @click="handl_end">确定</div>
                    <div class="btns2" @click="handle_clear">取消</div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import { mapState} from 'vuex'
 


export default {
    components: {
        
    },
    name: "homes",
    data() {
        return {
            loading: false,
            nsr_text:'请输入本人有效身份证号码',
            type_list:[
                {
                    title:'企业单位',
                    value:2,
                },
                {
                    title:'个人',
                    value:1,
                }
            ],
            forms:{
                type:1,//1个人 2企业
                taitou:'',//抬头
                company:'',//公司名称
                taxpayer_number:'',//纳税人识别码
                address:'',//公司地址
                mobile:'',//公司电话//联系电话
                bank:'',//公司开户行
                bank_num:'',//开户行帐号
                remark:'',//备注
                email:'',// 接收电子邮箱


                legal:'',//法人 
             
            }
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        if(this.$route.query.id){
            this.get_detial()
        }

    },
    methods: {
        get_detial(){
            this.loading = true
            this.$api("invoiceDetail", {
                id:this.$route.query.id
			}, "get").then((res) => {
                this.loading = false
                console.log('修改密码',res)
                if (res.code == 1) {
                    this.forms=res.data
                } else {
                    alertErr(res.msg)
                }
            });

        },
        change_type(){
           
            this.forms.taitou=''//抬头
            this.forms.company=''//公司名称
            this.forms.taxpayer_number=''//纳税人识别码
            this.forms.address=''//公司地址
            this.forms.mobile=''//公司电话//联系电话
            this.forms.bank=''//公司开户行
            this.forms. bank_num=''//开户行帐号
            this.forms.remark=''//备注
            this.forms.email=''// 接收电子邮箱
            this.forms.legal=''//法人 
            if(this.forms.type==1){
                this.nsr_text='请输入本人有效身份证号码'
            }else{
                this.nsr_text='请输入纳税人识别码'

            }

        },

        handl_end(){
            if(!this.forms.company&&this.forms.type==2){
                alertErr('请输入公司名称')
                return
            }
            
            if(!this.forms.taitou&&this.forms.type==1){
                alertErr('请输入发票抬头')
                return
            }
               
            if(!this.forms.taxpayer_number&&this.forms.type==2){
                alertErr('请输入纳税人识别码')
                return
            }

            if(!this.forms.email){
                alertErr('请输入接收电子邮箱')
                return
            }
            this.loading = true
            this.$api("invoiceAdd", {
                ...this.forms
			}, "post").then((res) => {
                this.loading = false
                console.log('修改密码',res)
                if (res.code == 1) {
                    if(this.forms.id){
                        alertSucc('修改成功')
                    }else{
                        alertSucc('添加成功')
                    }
                    this.$router.back()
                 
                } else {
                    alertErr(res.msg)
                }
            });

        },
        handle_clear(){
            this.$router.back()
        },



    },

}
</script>
<style scoped lang="less">
.user_mm {  
    .page_name{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        line-height: 56px;  
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;

    }
    .info_box{
        width: 1196px;
        min-height: 1013px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        margin-top: 18px;
        padding-top: 40px;

        .form_flex{
            display: flex;
            // align-items: center;
            padding-bottom: 24px;

            .form_title{
                width: 140px;
                height: 40px;
                line-height: 40px;
                text-align: right;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                padding-right: 24px;
                flex-shrink: 0;
                span{
                    color: #FD4C5C; 
                }
            }
            .input1{

            }
            .input2{
                display: flex;
                align-items: center;
                /deep/.el-select{
                    width: 400px;
                    height: 40px;
                }
                /deep/.el-input{
                    width: 400px;
                    height: 40px;
                }
                .input_text1{
                    padding-left: 15px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #888888;
    
                }

            }
           
             
          
            .btn_flex{
                display: flex;
                align-items: center;
                .btns1{
                    // width: 134px;
                    width: 76px;
                    height: 40px;
                    background: #377CFD;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #377CFD;
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #FFFFFF;

                }
                .btns2{
                    // width: 134px;
                    width: 76px;
                    height: 40px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #377CFD;
                    text-align: center;
                    line-height: 40px;
                    cursor: pointer;
                    margin-left: 24px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #377CFD;

                }
            }
        }
    }
}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .user_mm.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .user_mm.no-trans .page_name {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 56px;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        line-height: 1.6;
        font-size: 16px;
    }
    .user_mm.no-trans .info_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
        padding-top: 16px;
    }
    .user_mm.no-trans .info_box .form_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-bottom: 16px;
        flex-direction: column;
        align-items: stretch;
    }
    .user_mm.no-trans .info_box .form_flex .form_title {
        width: 100%;
        height: 40px;
        line-height: 1.6;
        font-size: 14px;
        padding-right: 16px;
        text-align: left;
        padding: 0;
    }
    .user_mm.no-trans .info_box .form_flex .input2 {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        max-width: 100%;
    }
    .user_mm.no-trans .info_box .form_flex .input2 /deep/ .el-select {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 40px;
    }
    .user_mm.no-trans .info_box .form_flex .input2 /deep/ .el-input {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 40px;
    }
    .user_mm.no-trans .info_box .form_flex .input2 .input_text1 {
        padding-left: 15px;
        font-size: 14px;
    }
    .user_mm.no-trans .info_box .form_flex .btn_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_mm.no-trans .info_box .form_flex .btn_flex .btns1 {
        width: 76px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .user_mm.no-trans .info_box .form_flex .btn_flex .btns2 {
        width: 76px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        line-height: 1.6;
        margin-left: 16px;
        font-size: 14px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
